/** Mean of the 1–5 scores. N/A is left out. */

export function aggregateScore(
  scores: Record<string, number | 'na' | undefined> | null | undefined
): number | null {
  const nums = Object.values(scores || {}).filter(
    (value): value is number => typeof value === 'number' && value >= 1 && value <= 5
  );
  if (!nums.length) return null;
  const mean = nums.reduce((sum, value) => sum + value, 0) / nums.length;
  return Math.round(mean * 10) / 10;
}

export function aggregateLabel(
  scores: Record<string, number | 'na' | undefined> | null | undefined
): string {
  const value = aggregateScore(scores);
  if (value == null) return '—';
  return value.toFixed(1);
}
